import { API_URLS } from '../configuration/apiConstants';
import { apiFetch } from '../configuration/apiFetch';
import { useSessionStore } from '../store/sessionStore';


//ACTIONS
export const getListActions =  () => {
  const myStore = useSessionStore.getState().myStore
  const fetchSettings = {
    method: "GET",
    url: API_URLS.ACTIONS,
    params: {
      storeId: myStore.id
    }
  }
  const dataFetch = new Promise ((resolve) => {
    apiFetch(fetchSettings).then((response)=>{
      response.forEach(action => {
        if(action.required){
          action.icon = action.icon.replaceAll("[", "").replaceAll("]", "").split(",")
        }else{
          action.icon = JSON.parse(action.icon)
        }
      })
      resolve(response)
    })
  })
  return dataFetch
}

export const saveAction =  ({data, type, actionId, successMsg}) => {
  console.log(type, actionId, successMsg)
  const fetchSettings = {
    method: type,
    url: type === "POST" ? API_URLS.NEW_ACTION : API_URLS.ACTION(actionId),
    data,
    successMsg
  }
  const dataFetch = new Promise ((resolve) => {
    apiFetch(fetchSettings).then((response)=>{
      resolve(response)
    })
  })
  return dataFetch
}

